var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 17V14M9.07 1.82L2.14 7.37C1.36 7.99 0.859998 9.3 1.03 10.28L2.36 18.24C2.6 19.66 3.96 20.81 5.4 20.81H16.6C18.03 20.81 19.4 19.65 19.64 18.24L20.97 10.28C21.13 9.3 20.63 7.99 19.86 7.37L12.93 1.83C11.86 0.970002 10.13 0.970002 9.07 1.82Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.a6a061dbaa0b1c00b5c7a3c4fc408169.svg";
export { ForwardRef as ReactComponent };